function formatCapitalizeFirstLetter(value) {
    if (!value)
        return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
}

function capitalizeTheFirstLetterOfEachWord(words) {
    var separateWord = words.toLowerCase().split(' ');
    for (var i = 0; i < separateWord.length; i++) {
        separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
            separateWord[i].substring(1);
    }
    return separateWord.join(' ');
}

function splitCamelCaseAndCapitalize(value) {
    if (!value) return ''
    value = value.toString()
    return value
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())
}

export default { formatCapitalizeFirstLetter, capitalizeTheFirstLetterOfEachWord, splitCamelCaseAndCapitalize };
